import { StorageEnum } from '@/utilities/storage/enums/StorageEnum'
import { StorageServiceInterface } from '@/utilities/storage/interfaces/StorageServiceInterface'

export class StorageService implements StorageServiceInterface {
  private readonly key: StorageEnum
  private readonly storageDriver: Storage

  constructor(key: StorageEnum, storageDriver?: Storage) {
    this.key = key
    this.storageDriver = storageDriver ?? window.localStorage
  }

  get(): string | null {
    return this.storageDriver.getItem(this.key)
  }

  set(value: string): void {
    this.storageDriver.setItem(this.key, value)
  }

  has(): boolean {
    return this.get() !== null
  }

  remove(): void {
    this.storageDriver.removeItem(this.key)
  }

  getObject<T extends Record<string, unknown> | unknown[]>(): T | null {
    if (!this.has()) {
      return null
    }

    try {
      const value = JSON.parse(this.get() as string)

      if (value !== null && typeof value === 'object') {
        return value
      }

      return null
    } catch {
      this.remove()
      return null
    }
  }

  setObject<T extends Record<string, unknown> | unknown[]>(value: T): void {
    this.set(JSON.stringify(value))
  }
}
